var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#0088FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2577_2007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6893 43.312C19.1611 41.836 17.9422 40.0705 17.1037 38.1184C16.2651 36.1664 15.8238 34.0668 15.8053 31.9424C15.7868 29.8179 16.1917 27.711 16.9962 25.7447C17.8006 23.7784 18.9887 21.9919 20.491 20.4896C21.9933 18.9874 23.7797 17.7993 25.746 16.9948C27.7124 16.1903 29.8192 15.7855 31.9437 15.8039C34.0682 15.8224 36.1677 16.2638 38.1198 17.1023C40.0718 17.9409 41.8374 19.1598 43.3133 20.688C46.2278 23.7056 47.8405 27.7472 47.8041 31.9424C47.7676 36.1375 46.0849 40.1505 43.1184 43.1171C40.1519 46.0836 36.1389 47.7663 31.9437 47.8027C27.7486 47.8392 23.7069 46.2265 20.6893 43.312ZM41.0573 41.056C43.4591 38.6542 44.8084 35.3966 44.8084 32C44.8084 28.6033 43.4591 25.3458 41.0573 22.944C38.6555 20.5422 35.398 19.1928 32.0013 19.1928C28.6046 19.1928 25.3471 20.5422 22.9453 22.944C20.5435 25.3458 19.1942 28.6033 19.1942 32C19.1942 35.3966 20.5435 38.6542 22.9453 41.056C25.3471 43.4578 28.6046 44.8071 32.0013 44.8071C35.398 44.8071 38.6555 43.4578 41.0573 41.056ZM30.4013 33.6V30.4H33.6013V40H30.4013V33.6ZM30.4013 24H33.6013V27.2H30.4013V24Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2577_2007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.5729cd520a02ee7b0adc892d43cce97c.svg";
export { ForwardRef as ReactComponent };